const organization = {
    require_membership: 'ユーザーは組織のメンバーである必要があります。',
    role_names_not_found: '無効なロール名が検出されました：{{names,list(type:conjunction)}}。これらのロールを作成してから次へ進んでください。',
};
export default Object.freeze(organization);
